const formatCallSign = (str = '') => str.replace(/\W/g, '').toLowerCase();

const getAudioUrl = (urlRoot, gamePk, callLetters) => {
    return `${urlRoot}/tv/g${gamePk}?callsign=${formatCallSign(callLetters)}`;
};

export default getAudioUrl;
